import React from 'react';

const KnowledgeGraphBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Paper texture */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Hand-drawn grid and doodles */}
      <div className="absolute inset-0">
        <svg
          viewBox="0 0 1920 1080"
          preserveAspectRatio="xMidYMid slice"
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* ========== BLUE GRID LINES ========== */}
          {/* Vertical lines */}
          <path className="grid-line" d="M 78 0 Q 82 50, 76 100 Q 80 180, 74 250 Q 81 350, 77 450 Q 73 550, 79 650 Q 75 750, 80 850 Q 76 950, 78 1080" />
          <path className="grid-line" d="M 172 0 Q 176 80, 170 150 Q 178 240, 168 320 Q 175 420, 171 510 Q 177 620, 169 720 Q 174 830, 172 920 Q 176 1000, 173 1080" />
          <path className="grid-line" d="M 258 0 Q 252 60, 260 140 Q 254 220, 262 310 Q 256 400, 259 490 Q 253 580, 261 680 Q 255 770, 258 860 Q 262 950, 257 1080" />
          <path className="grid-line" d="M 345 0 Q 350 90, 342 170 Q 348 260, 340 350 Q 352 450, 346 540 Q 341 640, 349 730 Q 343 820, 347 910 Q 344 1000, 346 1080" />
          <path className="grid-line" d="M 432 0 Q 426 70, 434 160 Q 428 250, 436 340 Q 430 430, 433 520 Q 438 610, 429 700 Q 435 790, 431 880 Q 437 970, 432 1080" />
          <path className="grid-line" d="M 525 0 Q 531 85, 522 175 Q 528 265, 520 355 Q 532 445, 526 535 Q 521 625, 529 715 Q 523 805, 527 895 Q 524 985, 526 1080" />
          <path className="grid-line" d="M 618 0 Q 612 75, 620 165 Q 614 255, 622 345 Q 616 435, 619 525 Q 624 615, 613 705 Q 621 795, 617 885 Q 623 975, 618 1080" />
          <path className="grid-line" d="M 705 0 Q 711 95, 702 185 Q 708 275, 700 365 Q 712 455, 706 545 Q 701 635, 709 725 Q 703 815, 707 905 Q 704 995, 706 1080" />
          <path className="grid-line" d="M 802 0 Q 796 65, 804 155 Q 798 245, 806 335 Q 800 425, 803 515 Q 808 605, 797 695 Q 805 785, 801 875 Q 807 965, 802 1080" />
          <path className="grid-line" d="M 888 0 Q 894 80, 885 170 Q 891 260, 883 350 Q 895 440, 889 530 Q 884 620, 892 710 Q 886 800, 890 890 Q 887 980, 889 1080" />
          <path className="grid-line" d="M 982 0 Q 988 70, 979 160 Q 985 250, 977 340 Q 989 430, 983 520 Q 978 610, 986 700 Q 980 790, 984 880 Q 981 970, 983 1080" />
          <path className="grid-line" d="M 1072 0 Q 1066 90, 1074 180 Q 1068 270, 1076 360 Q 1070 450, 1073 540 Q 1078 630, 1067 720 Q 1075 810, 1071 900 Q 1077 990, 1072 1080" />
          <path className="grid-line" d="M 1162 0 Q 1168 75, 1159 165 Q 1165 255, 1157 345 Q 1169 435, 1163 525 Q 1158 615, 1166 705 Q 1160 795, 1164 885 Q 1161 975, 1163 1080" />
          <path className="grid-line" d="M 1258 0 Q 1252 85, 1260 175 Q 1254 265, 1262 355 Q 1256 445, 1259 535 Q 1264 625, 1253 715 Q 1261 805, 1257 895 Q 1263 985, 1258 1080" />
          <path className="grid-line" d="M 1352 0 Q 1346 65, 1354 155 Q 1348 245, 1356 335 Q 1350 425, 1353 515 Q 1358 605, 1347 695 Q 1355 785, 1351 875 Q 1357 965, 1352 1080" />
          <path className="grid-line" d="M 1442 0 Q 1448 95, 1439 185 Q 1445 275, 1437 365 Q 1449 455, 1443 545 Q 1438 635, 1446 725 Q 1440 815, 1444 905 Q 1441 995, 1443 1080" />
          <path className="grid-line" d="M 1538 0 Q 1544 80, 1535 170 Q 1541 260, 1533 350 Q 1545 440, 1539 530 Q 1534 620, 1542 710 Q 1536 800, 1540 890 Q 1537 980, 1539 1080" />
          <path className="grid-line" d="M 1635 0 Q 1641 70, 1632 160 Q 1638 250, 1630 340 Q 1642 430, 1636 520 Q 1631 610, 1639 700 Q 1633 790, 1637 880 Q 1634 970, 1636 1080" />
          <path className="grid-line" d="M 1732 0 Q 1738 90, 1729 180 Q 1735 270, 1727 360 Q 1739 450, 1733 540 Q 1728 630, 1736 720 Q 1730 810, 1734 900 Q 1731 990, 1733 1080" />
          <path className="grid-line" d="M 1838 0 Q 1832 75, 1840 165 Q 1834 255, 1842 345 Q 1836 435, 1839 525 Q 1844 615, 1833 705 Q 1841 795, 1837 885 Q 1843 975, 1838 1080" />

          {/* Horizontal lines */}
          <path className="grid-line" d="M 0 68 Q 80 72, 160 65 Q 280 73, 400 67 Q 520 74, 640 66 Q 760 71, 880 69 Q 1000 75, 1120 64 Q 1240 72, 1360 68 Q 1480 74, 1600 66 Q 1720 71, 1840 70 Q 1880 73, 1920 68" />
          <path className="grid-line" d="M 0 158 Q 90 152, 180 160 Q 300 154, 420 162 Q 540 156, 660 159 Q 780 163, 900 153 Q 1020 161, 1140 157 Q 1260 164, 1380 152 Q 1500 160, 1620 156 Q 1740 163, 1860 155 Q 1890 158, 1920 156" />
          <path className="grid-line" d="M 0 242 Q 100 236, 200 244 Q 320 238, 440 246 Q 560 240, 680 243 Q 800 247, 920 237 Q 1040 245, 1160 241 Q 1280 248, 1400 236 Q 1520 244, 1640 240 Q 1760 247, 1880 239 Q 1900 242, 1920 240" />
          <path className="grid-line" d="M 0 332 Q 85 326, 170 334 Q 290 328, 410 336 Q 530 330, 650 333 Q 770 337, 890 327 Q 1010 335, 1130 331 Q 1250 338, 1370 326 Q 1490 334, 1610 330 Q 1730 337, 1850 329 Q 1885 332, 1920 330" />
          <path className="grid-line" d="M 0 412 Q 95 406, 190 414 Q 310 408, 430 416 Q 550 410, 670 413 Q 790 417, 910 407 Q 1030 415, 1150 411 Q 1270 418, 1390 406 Q 1510 414, 1630 410 Q 1750 417, 1870 409 Q 1895 412, 1920 410" />
          <path className="grid-line" d="M 0 502 Q 80 508, 160 500 Q 280 506, 400 498 Q 520 509, 640 503 Q 760 497, 880 505 Q 1000 499, 1120 507 Q 1240 501, 1360 504 Q 1480 510, 1600 498 Q 1720 506, 1840 502 Q 1880 505, 1920 503" />
          <path className="grid-line" d="M 0 588 Q 90 594, 180 586 Q 300 592, 420 584 Q 540 595, 660 589 Q 780 583, 900 591 Q 1020 585, 1140 593 Q 1260 587, 1380 590 Q 1500 596, 1620 584 Q 1740 592, 1860 588 Q 1890 591, 1920 589" />
          <path className="grid-line" d="M 0 678 Q 75 684, 150 676 Q 270 682, 390 674 Q 510 685, 630 679 Q 750 673, 870 681 Q 990 675, 1110 683 Q 1230 677, 1350 680 Q 1470 686, 1590 674 Q 1710 682, 1830 678 Q 1875 681, 1920 679" />
          <path className="grid-line" d="M 0 762 Q 85 768, 170 760 Q 290 766, 410 758 Q 530 769, 650 763 Q 770 757, 890 765 Q 1010 759, 1130 767 Q 1250 761, 1370 764 Q 1490 770, 1610 758 Q 1730 766, 1850 762 Q 1885 765, 1920 763" />
          <path className="grid-line" d="M 0 858 Q 95 852, 190 860 Q 310 854, 430 862 Q 550 856, 670 859 Q 790 863, 910 853 Q 1030 861, 1150 857 Q 1270 864, 1390 852 Q 1510 860, 1630 856 Q 1750 863, 1870 855 Q 1895 858, 1920 856" />
          <path className="grid-line" d="M 0 948 Q 80 942, 160 950 Q 280 944, 400 952 Q 520 946, 640 949 Q 760 953, 880 943 Q 1000 951, 1120 947 Q 1240 954, 1360 942 Q 1480 950, 1600 946 Q 1720 953, 1840 945 Q 1880 948, 1920 946" />
          <path className="grid-line" d="M 0 1028 Q 90 1034, 180 1026 Q 300 1032, 420 1024 Q 540 1035, 660 1029 Q 780 1023, 900 1031 Q 1020 1025, 1140 1033 Q 1260 1027, 1380 1030 Q 1500 1036, 1620 1024 Q 1740 1032, 1860 1028 Q 1890 1031, 1920 1029" />

          {/* ========== HAND-DRAWN DOODLES ========== */}

          {/* DNA Helix (top right area) */}
          <g transform="translate(1450, 80) rotate(-15)">
            <path className="doodle" d="M 0 0 Q 20 15, 0 30 Q -20 45, 0 60 Q 20 75, 0 90 Q -20 105, 0 120" />
            <path className="doodle" d="M 30 0 Q 10 15, 30 30 Q 50 45, 30 60 Q 10 75, 30 90 Q 50 105, 30 120" />
            <line className="doodle" x1="0" y1="15" x2="30" y2="15" />
            <line className="doodle" x1="0" y1="45" x2="30" y2="45" />
            <line className="doodle" x1="0" y1="75" x2="30" y2="75" />
            <line className="doodle" x1="0" y1="105" x2="30" y2="105" />
          </g>

          {/* Atom with orbits (left side) */}
          <g transform="translate(120, 180)">
            <ellipse className="doodle" cx="40" cy="40" rx="50" ry="20" transform="rotate(-30 40 40)" />
            <ellipse className="doodle" cx="40" cy="40" rx="50" ry="20" transform="rotate(30 40 40)" />
            <ellipse className="doodle" cx="40" cy="40" rx="50" ry="20" transform="rotate(90 40 40)" />
            <circle className="doodle" cx="40" cy="40" r="8" strokeWidth="2" />
          </g>

          {/* E = mc² equation (top center-left) */}
          <g transform="translate(280, 60)">
            <text className="doodle-text" style={{ fontSize: '24px', fontStyle: 'italic' }}>E = mc²</text>
          </g>

          {/* Neural network / mind map (center left) */}
          <g transform="translate(100, 420)">
            <text className="doodle-text" style={{ fontSize: '12px' }}>REMEMBER</text>
            <text className="doodle-text" y="14" style={{ fontSize: '12px' }}>FOR LATER!</text>
            <circle className="doodle" cx="40" cy="60" r="12" />
            <circle className="doodle" cx="100" cy="60" r="12" />
            <text className="doodle-text" x="36" y="64" style={{ fontSize: '10px' }}>+</text>
            <text className="doodle-text" x="96" y="64" style={{ fontSize: '10px' }}>−</text>
            <line className="doodle" x1="40" y1="48" x2="40" y2="20" />
            <line className="doodle" x1="40" y1="72" x2="40" y2="100" />
            <line className="doodle" x1="28" y1="60" x2="0" y2="60" />
            <line className="doodle" x1="52" y1="52" x2="70" y2="35" />
            <line className="doodle" x1="52" y1="68" x2="70" y2="85" />
            <line className="doodle" x1="100" y1="48" x2="100" y2="25" />
            <line className="doodle" x1="100" y1="72" x2="100" y2="95" />
            <line className="doodle" x1="112" y1="60" x2="135" y2="60" />
            <line className="doodle" x1="88" y1="52" x2="72" y2="38" />
            <line className="doodle" x1="88" y1="68" x2="72" y2="82" />
            <polygon className="doodle-fill" points="40,20 37,28 43,28" />
            <polygon className="doodle-fill" points="40,100 37,92 43,92" />
            <polygon className="doodle-fill" points="100,25 97,33 103,33" />
            <polygon className="doodle-fill" points="100,95 97,87 103,87" />
          </g>

          {/* Integral equation (right side) */}
          <g transform="translate(1550, 350)">
            <text className="doodle-text" style={{ fontSize: '20px' }}>∫ f(x)dx</text>
          </g>

          {/* Light bulb idea (top area) */}
          <g transform="translate(850, 40)">
            <path className="doodle" d="M 20 0 Q 0 20, 5 35 Q 0 50, 20 50 Q 40 50, 35 35 Q 40 20, 20 0" />
            <line className="doodle" x1="12" y1="55" x2="28" y2="55" />
            <line className="doodle" x1="14" y1="60" x2="26" y2="60" />
            <line className="doodle" x1="16" y1="65" x2="24" y2="65" />
            <line className="doodle" x1="20" y1="-8" x2="20" y2="-18" />
            <line className="doodle" x1="35" y1="0" x2="45" y2="-8" />
            <line className="doodle" x1="5" y1="0" x2="-5" y2="-8" />
          </g>

          {/* Small star */}
          <g transform="translate(1700, 600)">
            <path className="doodle" d="M 10 0 L 12 8 L 20 10 L 12 12 L 10 20 L 8 12 L 0 10 L 8 8 Z" />
          </g>

          {/* Pi symbol */}
          <g transform="translate(1600, 150)">
            <text className="doodle-text" style={{ fontSize: '28px' }}>π = 3.14...</text>
          </g>

          {/* Brain sketch (bottom left) */}
          <g transform="translate(60, 750)">
            <path className="doodle" d="M 30 50 Q 10 45, 5 30 Q 0 15, 15 5 Q 30 -5, 50 5 Q 65 10, 70 25 Q 75 40, 65 50 Q 55 60, 40 60 Q 25 60, 30 50" />
            <path className="doodle" d="M 20 20 Q 25 30, 35 25 Q 45 20, 40 30 Q 35 40, 50 35" />
            <circle className="doodle" cx="25" cy="35" r="3" />
            <circle className="doodle" cx="55" cy="25" r="3" />
          </g>

          {/* Square root equation */}
          <g transform="translate(1480, 500)">
            <text className="doodle-text" style={{ fontSize: '18px' }}>√x² = |x|</text>
          </g>

          {/* Checkmark / todo */}
          <g transform="translate(200, 650)">
            <rect className="doodle" x="0" y="0" width="20" height="20" rx="3" />
            <path className="doodle" d="M 4 10 L 8 15 L 16 5" strokeWidth="2" />
          </g>

          {/* Graph axes sketch */}
          <g transform="translate(1650, 750)">
            <line className="doodle" x1="0" y1="60" x2="80" y2="60" />
            <line className="doodle" x1="10" y1="70" x2="10" y2="0" />
            <path className="doodle" d="M 15 55 Q 30 20, 50 40 Q 65 55, 75 30" />
            <text className="doodle-text" x="75" y="70" style={{ fontSize: '10px' }}>x</text>
            <text className="doodle-text" x="0" y="5" style={{ fontSize: '10px' }}>y</text>
          </g>

          {/* Chemical formula */}
          <g transform="translate(380, 180)">
            <text className="doodle-text" style={{ fontSize: '16px' }}>H₂O</text>
          </g>

          {/* Summation */}
          <g transform="translate(1300, 250)">
            <text className="doodle-text" style={{ fontSize: '22px' }}>Σ aₙ</text>
          </g>

          {/* Arrow pointing somewhere */}
          <g transform="translate(550, 120)">
            <path className="doodle" d="M 0 20 Q 30 0, 60 15" />
            <polygon className="doodle-fill" points="60,15 52,10 54,18" />
          </g>

          {/* Small circles/dots scattered */}
          <circle className="doodle" cx="750" cy="150" r="4" />
          <circle className="doodle" cx="1100" cy="100" r="3" />
          <circle className="doodle" cx="1250" cy="180" r="5" />

          {/* Infinity symbol */}
          <g transform="translate(950, 200)">
            <path className="doodle" d="M 15 10 Q 0 0, 0 10 Q 0 20, 15 10 Q 30 0, 30 10 Q 30 20, 15 10" strokeWidth="1.5" />
          </g>

          {/* Question mark */}
          <g transform="translate(1750, 280)">
            <path className="doodle" d="M 10 0 Q 20 0, 20 10 Q 20 18, 10 20" />
            <circle className="doodle-fill" cx="10" cy="28" r="2" />
          </g>

        </svg>
      </div>
    </div>
  );
};

export default KnowledgeGraphBackground;
